<template>
<div class="site-detail">
    <Error @reload="getData()" v-if="networkError" />
    <div class="intro-page" v-else-if="showPage">
        <v-banner :site="poi_promotion" />
        <div class="intro-wrapper">
            <div class="intro-brief">
                <div class="intro-name">{{ poi_promotion.name }}</div>
            </div>
            <v-detail-content :detailArray="guideArray"
                              :site="poi_promotion"
                              siteType="promotion" />
        </div>
        <div class="site-wrapper" v-if="poi_promotion.poi">
            <div class="from-name" v-if="poi_promotion.poi.type === 'Site'">{{ $t('poi.siteTitle') }}</div>
            <div class="from-name" v-else-if="poi_promotion.poi.type === 'Hotel'">{{ $t('poi.hotelTitle') }}</div>
            <div class="from-name" v-else-if="poi_promotion.poi.type === 'SiteShop'">{{ $t('poi.mallTitle') }}</div>
            <div class="from-name" v-else-if="poi_promotion.poi.type === 'ShowItem'">{{ $t('poi.showTitle') }}</div>
            <div class="from-name" v-else-if="poi_promotion.poi.type === 'SiteActivity'">{{ $t('poi.eventTitle') }}</div>
            <div class="from-name" v-else-if="poi_promotion.poi.type === 'Merchant'">{{ $t('poi.merchantTitle') }}</div>
            <div class="list-wrapper">
                <div class="from-card">
                    <v-card :list="[ poi_promotion.poi ]"
                            :category="poi_promotion.poi.type"
                            cardType="list_model">
                    </v-card>
                </div>
            </div>
        </div>
        <div class="others">
            <div class="others-title">{{ $t('poi.otherPromotion') }}</div>
            <div class="others-list">
                <div class="item"
                     v-for="item in recommends"
                     :key="item.id"
                     @click="handleDetail(item.id)">
                    <div class="item-img">
                        <img class="other-img" v-lazy="item.image || '/image/default_img.jpg'"/>
                        <img src="@/assets/scenic/sentosa-wave-orange.svg" class="wave"/>
                    </div>
                    <div class="item-detail">
                        <div class="name">{{ item.name }}</div>
                        <div class="date">{{ item.time }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { getPromotionDetail } from '@/fetch/api'
import { GetDistance, formatMinutes } from '@/utils/index'
import Error from '@/components/Error.vue'
import DetailContent from '@/components/scenic/DetailContent.vue'
import Banner from '@/components/scenic/Banner.vue'
import Card from '@/components/scenic/Card.vue'

export default {
    data () {
        return {
            siteId: '1',
            showPage: false,
            id: '',
            poi_promotion: {},
            guideArray: [],
            networkError: false,
            recommends: []
        }
    },
    components: {
        Error,
        'v-detail-content': DetailContent,
        'v-banner': Banner,
        'v-card': Card
    },
    created () {
        document.title = this.$t('poi.promotionTitle')
        this.toast = this.$createToast({
            time: 0,
            txt: this.$t('common.loadingMsg'),
            mask: true
        })
        this.toast.show()
        navigator.geolocation.getCurrentPosition((res) => {
            const longitude = res.coords.longitude
            const latitude = res.coords.latitude
            this.geoData = {
                lon: longitude,
                lat: latitude
            }
            // console.log(longitude, latitude)
            if (longitude) {
                this.getData()
            }
        }, err => {
            this.geoData = {
                lon: 103.82241,
                lat: 1.2651
            }
            this.getData()
        }, { timeout: 5000, enableHighAccuracy: true })
    },
    watch: {
        '$route' () {
            this.getData()
        }
    },
    methods: {
        getData () {
            const params = {
                lon: this.geoData.lon,
                lat: this.geoData.lat
            }
            if (this.$route.query.language === 'zh') {
                params.locale = 'cn'
            } else {
                params.locale = 'en'
            }
            getPromotionDetail(this.$route.params.id, params).then(res => {
                this.poi_promotion = res.poi_promotion
                this.guideArray = this.processGuide(res.poi_promotion)
                this.showPage = true
                this.recommends = res.recommends
                this.toast.hide()
                window.scrollTo(0,0)
            }).catch(err => {
                console.log(err)
                this.toast.hide()
                this.networkError = true
            })
        },
        processGuide (poi_promotion) {
            let guideArray = []
            if (poi_promotion.description) {
                guideArray.push({
                    id: 'description',
                    text: this.$t('poi.promotionDesc'),
                    content: poi_promotion.description
                })
            }
            if (poi_promotion.time) {
                guideArray.push({
                    id: 'time',
                    text: this.$t('poi.promotionTime'),
                    content: poi_promotion.time
                })
            }
            if (poi_promotion.phone_number) {
                guideArray.push({
                    id: 'number',
                    text: this.$t('poi.number'),
                    content: poi_promotion.phone_number
                })
            }
            if (poi_promotion.website) {
                guideArray.push({
                    id: 'website',
                    text: this.$t('poi.website'),
                    content: poi_promotion.website
                })
            }
            if (poi_promotion.usage) {
                guideArray.push({
                    id: 'usage',
                    text: this.$t('poi.promotionNote'),
                    content: poi_promotion.usage
                })
            }
            if (poi_promotion.traffic_strategy) {
                guideArray.push({
                    id: 'traffic',
                    text: this.$t('poi.traffic'),
                    content: poi_promotion.traffic_strategy
                })
            }
            if (poi_promotion.address) {
                guideArray.push({
                    id: 'address',
                    text: this.$t('poi.address'),
                    content: poi_promotion.address
                })
            }
            return guideArray
        },
        handleDetail (id) {
            let url = `/promotionDetail/${id}`
            if (this.$route.query.language === 'zh') url += '?language=zh'
            this.$router.push(url)
        },
    }
}
</script>

<style lang="scss" scoped>
.intro-page .intro-brief {
  padding-bottom: 15px;
}

.site-wrapper {
  padding: 12px 12px 20px;
  border-bottom: 8px solid #f0f0f0;
}

.site-wrapper .from-name {
  font-size: 18px;
  font-weight: bold;
  font-family: GothamBold;
  color: #222215;
  margin-bottom: 14px;
}

.list-wrapper {
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
  height: 100px;
  overflow: hidden;
}

.from-card {
  margin: -12px -12px 0;
}

.others {
  padding: 15px 12px;
}

.others .others-title {
  font-size: 18px;
  font-weight: bold;
  font-family: GothamBold;
  color: #222215;
  margin-bottom: 6px;
}

.others-list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.others-list .item {
  width: 170px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  margin-top: 12px;
}

.others-list .other-img {
  width: 100%;
  height: 107px;
}

.others-list .item-img {
  position: relative;
}

.others-list .item .wave {
  position: absolute;
  top: 102px;
  left: 0;
  width: 100%;
  height: 10px;
}

.others-list .item-detail {
  padding: 10px 11px 8px;
}

.item-detail .name {
  color: #333333;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 7px;
}

.item-detail .date {
  font-size: 12px;
  font-weight: bold;
  font-family: GothamBold;
  color: #60c2ed;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>